const Pagination = ( props ) => {
  if ( props.maxPages === 1 ) {
    return (
      ''
    );
  }

  let maxPagesArr = [...Array( props.maxPages ).keys()]

  const getPageNumber = ( number ) => {
    if ( number === props.page ) {
      return (
        <span className="page-numbers current" key={ number } number={ number }>{ number }</span>
      )
    }

    return (
      <span className="page-numbers" key={ number } number={ number } onClick={ ( event ) => props.pageChange( event.target.getAttribute( 'number' ) ) }>{ number }</span>
    )
  }

  return (
    <>
      <div className="pagination">
        {
          maxPagesArr && maxPagesArr.map( number => {
            return (
              getPageNumber( number + 1 )
            )
          })
        }
      </div>
    </>
  )
}

export default Pagination;
